<template>
  <div class="col-6 float-right" v-for="(cat, index)  in category.data.massege" :key="index">
    <div @click="ClickMethod(index)" style="position: relative">
      <h2>{{ category.data.lang[index] }}</h2>
      <v-divider v-if="cat!=''"/>
      <template v-else>
        <div style="width: 100%;height: 30px;border: 0"></div>
      </template>

      <h3 v-text="cat"></h3>
    </div>
  </div>
</template>

<script>
import http from "@/plugins/axios";
import router from "@/router";

export default {
  name: 'data-view',

  data: () => ({
    category: {
      data: [],
      lang: []
    },
  }),
  methods: {
    ClickMethod(name) {
      if (name == "programs")
        router.push("/program")
      if (name == "sans")
        router.push("/sans/0")
      if (name == "userSales")
        router.push("/userSales")
      if (name == "paySuccessful")
        router.push("/pay/successful")
      if (name == "payUnSuccessful")
        router.push("/pay/unSuccessful")
      if (name == "payOnline")
        router.push("/pay/online")
      if (name == "paySaderat")
        router.push("/pay/saderat")
      if (name == "payMelli")
        router.push("/pay/melli")
      if (name == "payAll")
        router.push("/pay/all")
      if (name == "comment")
        router.push("/comment")
      if (name == "logout")
        router.push("/logout")
      if (name == "reload")
        location.reload();
    },
    getSans() {
      const AuthStr = (localStorage.getItem("token"));
      http.post("/getData.php", {
            length: 50
          },
          {headers: {Token: AuthStr}})
          .then(response => {
            this.category = response.data;
          });
    }
  },
  mounted() {
    this.getSans();
  },
}
</script>


<style scoped>
h2, h3 {
  font-size: 12pt;
  text-align: center;
  padding: 5px;
  direction: rtl;

}

.col-6 div {
  width: 90%;
  margin: 10px auto;
  background: #e8e8e8;
  border-radius: 10px;
  border: 1px solid #bebebe;
}
</style>